import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "BizChatContextHandlers" */ './lazyIndex'),
    { name: 'BizChatContextHandlers' }
);

export const lazyInitializeContextHandlers: LazyAction<
    typeof lazyIndex.initializeContextHandlers,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeContextHandlers);

export const lazyGetCalendarContextAnnotation: LazyAction<
    typeof lazyIndex.getCalendarContextAnnotation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getCalendarContextAnnotation);

export const lazyGetContextualChatData: LazyAction<
    typeof lazyIndex.getContextualChatData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getContextualChatData);

export const lazyGetDefaultAgentMentionForModule: LazyAction<
    typeof lazyIndex.getDefaultAgentMentionForModule,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getDefaultAgentMentionForModule);

export const lazyBizChatHandleoff: LazyImport<
    typeof lazyIndex.bizChatHandleoff,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.bizChatHandleoff);

// Non-lazy exports: lightweight module-scope coordination used synchronously at click time
export {
    markPendingDraftRequest,
    clearPendingDraftRequest,
    DEFAULT_PENDING_DRAFT_TIMEOUT_MS,
} from './utils/pendingDraftAssistantGetDraft';
